"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targets = exports.getClosestTranslationTarget = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var targets = {
  norway: {
    nature: [10, 25, 50, 100, 150, 200, 300, 500, 1000, 1500, 2000, 2500, 3000, 4000, 6000, 8000, 10000, 12000, 14000, 16000, 20000, 25000, 30000, 35000, 40000],
    transport: [10, 25, 50, 100, 200, 300, 500, 1000, 1500, 2000, 2500, 4000, 6000, 10000, 25000, 35000],
    energy: [10, 25, 50, 100, 200, 300, 500, 750, 1000, 1500, 2000, 2500, 4000, 8000, 12000, 16000, 20000]
  },
  japan: {
    nature: [10, 25, 50, 100, 150, 200, 300, 500, 1000, 1500, 2000, 2500, 3000, 4000, 6000, 8000, 10000, 12000, 14000, 16000, 20000, 25000, 30000, 35000, 40000],
    transport: [10, 25, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 1700, 2200],
    energy: [10, 25, 50, 100, 200, 300, 500, 750, 1000, 1500, 2000, 2500, 4000, 8000, 12000, 16000, 20000]
  },
  united_kingdom: {
    nature: [10, 25, 50, 100, 150, 200, 300, 500, 1000, 1500, 2000, 2500, 3000, 4000, 6000, 8000, 10000, 12000, 14000, 16000, 20000, 25000, 30000, 35000, 40000],
    transport: [10, 25, 50, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 4000],
    energy: [10, 25, 50, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 4000, 8000, 12000, 16000, 20000]
  }
};
exports.targets = targets;
var getClosestTranslationTarget = function getClosestTranslationTarget(passedValue) {
  var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'transport';
  var dataSource = arguments.length > 2 ? arguments[2] : undefined;
  var value = Number(passedValue);
  var _targets$dataSource$c = _slicedToArray(targets[dataSource][category], 1),
    currentRangeValue = _targets$dataSource$c[0];
  var targetLength = targets[dataSource][category].length;
  for (var x = 0; x < targetLength; x++) {
    if (targets[dataSource][category][x] > value || x === targetLength) {
      return currentRangeValue;
    }
    currentRangeValue = targets[dataSource][category][x];
  }
  return currentRangeValue;
};
exports.getClosestTranslationTarget = getClosestTranslationTarget;
//# sourceMappingURL=getClosestTranslationTarget.js.map